var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MagnifyingGlass") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.73 20.31l-6.7-7.1s-.03-.02-.04-.03a8.213 8.213 0 001.61-4.89C16.6 3.72 12.87 0 8.3 0S0 3.72 0 8.3s3.72 8.3 8.3 8.3c2.03 0 3.89-.73 5.33-1.95l6.65 7.04a1.02 1.02 0 001.42.04c.4-.38.42-1.01.04-1.41l-.01-.01zM8.3 14.59c-3.47 0-6.3-2.83-6.3-6.3 0-3.47 2.83-6.3 6.3-6.3 3.47 0 6.3 2.83 6.3 6.3 0 3.47-2.83 6.3-6.3 6.3z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/MagnifyingGlass.a42d5b16cfe4653e1d9649abb146d2bb.svg";
export { ForwardRef as ReactComponent };